export default __webpack_public_path__ + "static/media/work-7.31d40c2c.jpg";